export default function IconProvider
() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none">
            <path
                d="M27.6028 17.0978C31.1139 17.0978 33.9598 14.2519 33.9598 10.7408C33.9598 7.23162 31.1139 4.38379 27.6028 4.38379"
                stroke="#FF5F39"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M30.526 24.0078C31.5749 24.0792 32.6161 24.2295 33.6438 24.4571C35.0686 24.7405 36.7847 25.3247 37.394 26.6031C37.7834 27.4225 37.7834 28.3769 37.394 29.1964C36.7866 30.4747 35.0686 31.0589 33.6438 31.352"
                stroke="#FF5F39"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2076 25.375C22.3223 25.375 28.3998 26.4528 28.3998 30.7583C28.3998 35.0657 22.3609 36.1802 15.2076 36.1802C8.09283 36.1802 2.01733 35.1043 2.01733 30.7969C2.01733 26.4895 8.05427 25.375 15.2076 25.375Z"
                stroke="#184353"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2076 19.2299C10.5146 19.2299 6.75476 15.4682 6.75476 10.7751C6.75476 6.08402 10.5146 2.32227 15.2076 2.32227C19.9007 2.32227 23.6624 6.08402 23.6624 10.7751C23.6624 15.4682 19.9007 19.2299 15.2076 19.2299Z"
                stroke="#184353"
                stroke-width="2.89217"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
